import 'react-toastify/dist/ReactToastify.css';
import './app.scss';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import React from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col } from 'reactstrap';
import { BrowserRouter as Router, NavLink, Route, Redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { hot } from 'react-hot-loader';

import { IRootState } from 'app/shared/reducers';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile, getConfig } from 'app/shared/reducers/application-profile';
import { setLocale } from 'app/shared/reducers/locale';
import Header from 'app/shared/layout/header/header';
import HeaderReg from 'app/shared/layout/header/headerReg';
import Footer from 'app/shared/layout/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES, LIST_PATHNAME, BUILD_MODE } from 'app/config/constants';
import AppRoutes from 'app/routes';
import AppRoutesAdmin from 'app/routes-admin';
import AddRoutesReg from 'app/routes-reg';
import MenuLeftPage from 'app/shared/layout/menus/menuLeft';

import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

const baseHref = document
  .querySelector('base')
  .getAttribute('href')
  .replace(/\/$/, '');

export interface IAppProps extends StateProps, DispatchProps {}

export interface IAppState {
  menuOpen: boolean;
  expanded: boolean;
  select: String;
}

export class App extends React.Component<IAppProps, IAppState> {
  state: IAppState = {
    menuOpen: true,
    expanded: false,
    select: '/admin'
  };
  onSelect = selected => {
    this.setState({
      select: selected
    });
  };

  onToggle = expanded => {
    this.setState({ expanded: expanded });
  };

  componentWillMount() {
    this.props.getConfig();
  }

  componentDidMount() {
    this.props.getSession();
    // this.props.getProfile();
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  renderHeader() {}

  layoutMenu = (select, expanded, isBuildAdmin) => {
    return (
      <div>
        <React.Fragment>
          <SideNav
            style={{ marginLeft: '-15px', marginTop: '21px', background: '#13559f' }}
            onSelect={this.onSelect}
            onToggle={this.onToggle}
          >
            <SideNav.Toggle />
            <SideNav.Nav defaultSelected="home" selected={select}>
              {/* group quan tri dinh danh */}
              <NavItem eventKey="/admin">
                <NavIcon>
                  <img style={{ height: '30px' }} src={require('app/images/admin/ic_identity.svg')} alt="" />
                </NavIcon>
                <NavText>Quản trị danh tính Công dân</NavText>
                <NavItem eventKey="/admin">
                  <NavText>
                    <NavLink style={{ color: 'black' }} to="/admin">
                      Công dân
                    </NavLink>
                  </NavText>
                </NavItem>
                <NavItem eventKey="">
                  <NavText>{/* <NavLink style ={{color: 'black'}} to="">Doanh nghiệp</NavLink> */}</NavText>
                </NavItem>
                <NavItem eventKey="">
                  <NavText>{/* <NavLink style ={{color: 'black'}} to="">Cơ quan nhà nước</NavLink> */}</NavText>
                </NavItem>
                <NavItem eventKey="/admin/remove">
                  <NavText>
                    <NavLink style={{ color: 'black' }} to="/admin/remove">
                      Danh sách tài khoản đã xoá
                    </NavLink>
                  </NavText>
                </NavItem>
              </NavItem>

              {/* group quan tri admin */}
              <NavItem eventKey="/admin/manager">
                <NavIcon>
                  <NavLink to="/admin/manager">
                    {/* <i className="fa fa-user-o" style={{ fontSize: '1.75em' }} />{' '} */}
                    <img style={{ height: '30px' }} src={require('app/images/admin/ic_admin.svg')} alt="" />
                  </NavLink>
                </NavIcon>
                <NavText>Quản trị admin</NavText>

                <NavItem eventKey="/admin/manager">
                  <NavText>
                    <NavLink style={{ color: 'black' }} to="/admin/manager">
                      Tài khoản quản trị
                    </NavLink>
                  </NavText>
                </NavItem>

                <NavItem eventKey="/admin/vinaInfo">
                  <NavText>
                    <NavLink style={{ color: 'black' }} to="/admin/vinaInfo">
                      Tra cứu thông tin nhà mạng
                    </NavLink>
                  </NavText>
                </NavItem>
              </NavItem>

              {/* group covid */}
              <NavItem eventKey="/admin/active">
                <NavIcon>
                  <NavLink to="/admin/active">
                    <img style={{ height: '30px' }} src={require('app/images/admin/ic_covid.svg')} alt="" />
                  </NavLink>
                </NavIcon>
                <NavText>
                  <NavLink to="/admin/active">
                    <p className="p-text">Kích hoạt tài khoản đăng ký </p>
                    <p className="p-text" style={{ marginTop: '-15px' }}>
                      gói hỗ trợ NCOVI
                    </p>
                  </NavLink>
                </NavText>
              </NavItem>
            </SideNav.Nav>
          </SideNav>
          <main />
        </React.Fragment>
        <div style={{ marginLeft: expanded ? 200 : 25, padding: '15px 20px 0 20px' }}>
          {isBuildAdmin ? <AppRoutesAdmin /> : <AppRoutes />}
        </div>
      </div>
    );
  };

  renderBody = config => {
    const { expanded, select } = this.state;
    if (!config || !config.buildMode) return null;
    switch (config.buildMode) {
      case BUILD_MODE.ADMIN:
        return window.location.pathname.startsWith('/admin') ? (
          window['is_mobile']() ? (
            <div style={{ marginTop: window.innerWidth <= 414 ? '40px' : '0px', marginLeft: '-30px', marginRight: '-30px' }}>
              {this.state.menuOpen ? (
                <div style={{ backgroundColor: '#0B53A1' }}>
                  <MenuLeftPage isAuthenticated={this.props.isAuthenticated} isAdmin={this.props.isAdmin} />
                </div>
              ) : null}
              <div>
                <AppRoutesAdmin />
              </div>
            </div>
          ) : (
            this.layoutMenu(select, expanded, true)
          )
        ) : (
          <AppRoutesAdmin />
        );
      case BUILD_MODE.BOTH:
        return window.location.pathname.startsWith('/admin') ? (
          window['is_mobile']() ? (
            <div style={{ marginTop: window.innerWidth <= 414 ? '40px' : '0px', marginLeft: '-30px', marginRight: '-30px' }}>
              {this.state.menuOpen ? (
                <div style={{ backgroundColor: '#0B53A1' }}>
                  <MenuLeftPage isAuthenticated={this.props.isAuthenticated} isAdmin={this.props.isAdmin} />
                </div>
              ) : null}
              <div>
                <AppRoutes />
              </div>
            </div>
          ) : (
            this.layoutMenu(select, expanded, false)
          )
        ) : (
          <AppRoutes />
        );
      default:
        return <AddRoutesReg />;
    }
  };

  render() {
    const pathname = window.location.pathname;
    // const paddingTop = '60px';
    return (
      <Router basename={baseHref}>
        <div className="app-container" style={{ paddingTop: '60px' }}>
          {window.location !== window.parent.location ? null : this.props.config.buildMode != BUILD_MODE.REG &&
            window.location.pathname.startsWith('/admin') ? ( //check page loaded by iframe or not
            <ErrorBoundary>
              <Header
                isAuthenticated={this.props.isAuthenticated}
                isAdmin={this.props.isAdmin}
                currentLocale={this.props.currentLocale}
                onLocaleChange={this.props.setLocale}
                ribbonEnv={this.props.ribbonEnv}
                isInProduction={this.props.isInProduction}
                isSwaggerEnabled={this.props.isSwaggerEnabled}
                toggleMenu={this.toggleMenu}
              />
            </ErrorBoundary>
          ) : (
            !window.location.pathname.startsWith('/approve-management') && (
              <ErrorBoundary>
                <HeaderReg />
              </ErrorBoundary>
            )
          )}

          <div className="container-fluid view-container" id="app-view-container">
            <Card className="jh-card bg-jh-card" id="body">
              <ErrorBoundary>{this.renderBody(this.props.config)}</ErrorBoundary>
            </Card>
            {!window.location.pathname.startsWith('/approve-management') && <Footer />}
          </div>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = ({ authentication, applicationProfile, locale }: IRootState) => ({
  currentLocale: locale.currentLocale,
  isAuthenticated: authentication.isAuthenticated,
  isAdmin: hasAnyAuthority(authentication.account.authorities, [AUTHORITIES.ADMIN]),
  ribbonEnv: applicationProfile.ribbonEnv,
  isInProduction: applicationProfile.inProduction,
  isSwaggerEnabled: applicationProfile.isSwaggerEnabled,
  config: applicationProfile.config
});

const mapDispatchToProps = { setLocale, getSession, getProfile, getConfig };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hot(module)(App));
